<div class="search-section" style="background-image: url('../../../assets/images/bg_image_{{carCriteria.businessLine?.toLowerCase()}}.webp'); background-size: 100% auto;">

  <h3> Démarrer votre recherche </h3>

  <div class="search-form">

    <div class="search-form-top">

      <button class="simple-button-{{carCriteria.businessLine?.toLowerCase()}}" mat-button disabled>
        <mat-icon>directions_car</mat-icon>
        Véhicules
      </button>
      <!--
      <button class="simple-button-{{carCriteria.businessLine?.toLowerCase()}}" mat-button (click)="submitSearchForm()" >
        <mat-icon>directions_car</mat-icon>
        Véhicules
      </button>

      <button class="simple-button-{{carCriteria.businessLine?.toLowerCase()}}" mat-button (click)="submitSearchForm()" >
        <mat-icon>local_shipping</mat-icon>
        Engins
      </button>
      -->
    </div>

    <mat-divider></mat-divider>

    <div class="search-form-details">

      <!-- <mat-form-field >
      <mat-label>Vente/Location</mat-label>
      <mat-select name="businessLines" (selectionChange)="onBusinessLineChange()" [(ngModel)]="carCriteria.businessLine">
        <mat-option *ngFor="let line of businessLinesBD" [value]="line" >{{line}}</mat-option>
      </mat-select>
    </mat-form-field> -->

    <mat-form-field appearance="outline">
      <mat-label>Marque(s)</mat-label>
      <mat-select name="makes" [multiple]="isCarSearch()" (selectionChange)="onMakesChange($event.value)" [(ngModel)]="selectedMakes">
        @for (make of (makes$ | async)!; track make; let i = $index) {
          <mat-option [value]="make" >{{make.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- <mat-form-field *ngIf = "searchForm.value.makes !=''"> -->
    <mat-form-field appearance="outline">
      <mat-label>Modèle(s)</mat-label>
      <mat-select name="models"  [disabled]="carCriteria.makes.length===0" [multiple]="isCarSearch()" (selectionChange)="onModelsChange($event.value)" [(ngModel)]="selectedModels">
        @for (model of (models$ | async)!; track model) {
          <mat-option [value]="model" >{{model.makeName}} {{model.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Ville(s)</mat-label>
      <mat-select name="cities" [multiple]="isCarSearch()" (selectionChange)="onCriteriaChange()" [(ngModel)]="carCriteria.cities">
        @for (city of citiesBD; track city; let i = $index) {
          <mat-option [value]="city" >{{city}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (carCriteria.businessLine == CarBusinessLine.BUY) {
      <mat-form-field>
        <mat-label>Boîte</mat-label>
        <mat-select name="gearBoxes" [multiple]="isCarSearch()" (selectionChange)="onCriteriaChange()" [(ngModel)]="carCriteria.gearBoxes">
          @for (gb of gearboxesBD; track gb) {
            <mat-option [value]="gb" >{{gb}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (carCriteria.businessLine == CarBusinessLine.RENT) {
      <mat-form-field>
        <mat-label> Dates </mat-label>
        <mat-date-range-input matInput [rangePicker]="picker2" [dateFilter]="filterPastDates">
          <input required matStartDate placeholder="Début" name="start" (dateChange)="onSelectedDatesChange($event, false)" [(ngModel)]="carCriteria.startDate" >
          <input required matEndDate placeholder="Fin" name="end" (dateChange)="onSelectedDatesChange($event, true)" [(ngModel)]="carCriteria.endDate" >
        </mat-date-range-input>
        <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-date-range-picker #picker2></mat-date-range-picker>
      </mat-form-field>
    }

    @if (isCarSearch()) {
      <mat-form-field appearance="outline">
        <mat-label>Prix Maximum</mat-label>
        <input type="number" matInput="" name ="price" placeholder="Prix Maximum"  step="100000" (change)="onCriteriaChange()" [(ngModel)]="carCriteria.priceMax" >
        <span matTextSuffix>FCFA</span>
      </mat-form-field>
    }

    @if (!isCarSearch()) {
      <mat-form-field>
        <mat-label>Service demandé</mat-label>
        <mat-select name="services" [multiple]="isCarSearch()" (selectionChange)="onCriteriaChange()" [(ngModel)]="appointment.services" required>
          @for (serv of serviceTypesBD; track serv) {
            <mat-option [value]="serv.code" >{{serv.title}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (!isCarSearch() && appointment.services.includes(ServiceType.REPAIR)) {
      <mat-form-field>
        <mat-label>Catégorie panne</mat-label>
        <mat-select name="jobCategories" multiple [(ngModel)]="appointment.jobCategories" required>
          @for (serv of jobCategoriesBD; track serv) {
            <mat-option [value]="serv.code" >{{serv.title}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <button class="cta-button-{{carCriteria.businessLine!.toLowerCase()}}" mat-button (click)="submitSearchForm()" >
      <mat-icon>{{isCarSearch() ? "directions_car" : "today"}}</mat-icon>
      @if ((fetchingPreview$ | async)) {
        <span style="text-align:center">
          <mat-spinner  [diameter]="20"></mat-spinner>
        </span>
      }
      @if (!(fetchingPreview$ | async) && isCarSearch()) {
        <span>
          {{ (carsPreviewTotalCount$ | async) }} véhicules
        </span>
      }

      @if (!(fetchingPreview$ | async) && !isCarSearch()) {
        <span>
          Prendre rendez-vous ({{ (dealersPreviewTotalCount$ | async) }})
        </span>
      }
    </button>

  </div>
  <div class="search-form-buttons">

  </div>
</div>
</div>
<!--
<div class="value-prop">
  <div class="value-prop-item">
    <div class="value-prop-item-section"><mat-icon class="mat-icon-{{carCriteria.businessLine!.toLowerCase()}}">directions_car</mat-icon></div>
    <div class="value-prop-item-section">&nbsp; &nbsp; 3000 véhicules, &nbsp; &nbsp; 34 marques</div>
  </div>
  <div class="value-prop-item">
    <div class="value-prop-item-section"><mat-icon class="mat-icon-{{carCriteria.businessLine!.toLowerCase()}}">today</mat-icon></div>
    <div class="value-prop-item-section"> &nbsp; Garantie 6 mois &nbsp;  et plus</div>
  </div>
  <div class="value-prop-item">
    <div class="value-prop-item-section"><mat-icon class="mat-icon-{{carCriteria.businessLine!.toLowerCase()}}">flag_2</mat-icon></div>
    <div class="value-prop-item-section">30 jours d'éssai, Retours gratuits</div>
  </div>
  <div class="value-prop-item">
    <div class="value-prop-item-section"><mat-icon class="mat-icon-{{carCriteria.businessLine!.toLowerCase()}}">settings_heart</mat-icon></div>
    <div class="value-prop-item-section">Révision et entretien</div>
  </div>
</div> -->

<div class="value-prop">
  @for (val of valuePropositions [carCriteria.businessLine!]; track val) {
    <div class="value-prop-item">
      <div class="value-prop-item-section"><mat-icon class="mat-icon-{{carCriteria.businessLine!.toLowerCase()}}">{{val.icon}}</mat-icon></div>
      <div class="value-prop-item-section"><span [innerHTML]="val.text"></span></div>
    </div>
  }
</div>

<div class="middle-content">
  <h1>Véhicules récemment postés @if ((selectedCountryCodes$ | async)!.length>0) {
    <span> (@for (c of (selectedCountryCodes$ | async)!; track c; let i = $index) {
      <span>@if (i!==0) {
        <span>, </span>
      }{{getCountryName(c)}}</span>
    })</span>
  }</h1>
  <div class="middle-recent-cars">
    @if (isCarSearch()) {
      <div class="recent-cars">
        <app-car-box-list
          [businessLine]="carCriteria.businessLine!"
          [carBriefs]="recentCarBriefs" >
          <!-- [favorites]="(currentUserFavorites$ | async)!"
          [carImageDatas]="(carImagesFolder != undefined)?carImagesFolder![0]:defaultImageDatas"> -->
        </app-car-box-list>
      </div>
    }

  </div>

  <div class="middle-quick-links">
    @if (isCarSearch()) {
      <div class="quick-links">
        <div class="link-tables" >
          @for (quickLink of quickLinks; track quickLink) {
            <div class="link-table">
              <h4>{{quickLink.title}}</h4>
              @for (link of quickLink.links; track link) {
                <h6>
                  <a [routerLink]="['/'+carCriteria.businessLine!.toString().toLowerCase()+'/search']"
                    [queryParams]="getCarCriteriaQueryParams(quickLink.title, link)">
                    {{ quickLink.title }} {{ link }}
                  </a>
                </h6>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>



